<!--  -->
<template>
  <div>
    <!-- 下拉菜单 -->
    <div class="menuShow none" id="menuBox">
      <div class="menuList">
        <ul>
          <li style="font-size: 1.5rem;" @click="hideMenu()">
            <a href="javascript:;">×</a>
          </li>
          <li @click="gotoDiv('video')">
            <a href="javascript:;">教学视频</a>
          </li>
          <li @click="gotoDiv('plan')">
            <a href="javascript:;">定制计划</a>
          </li>
          <li @click="gotoDiv('community')">
            <a href="javascript:;">社区交流</a>
          </li>
          <li @click="gotoDiv('college')">
            <a href="javascript:;">学院视频</a>
          </li>
          <li @click="gotoDiv('partner')">
            <a href="javascript:;">战略合作</a>
          </li>
          <li @click="gotoDiv('about')">
            <a href="javascript:;">关于我们</a>
          </li>
          <li @click="gotoDiv('contact')">
            <a href="javascript:;">联系我们</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showMenu() {
      var animation = function() {
        let animationClass = "slipShow";
        var ele = document.getElementById("menuBox");
        ele.className = "menuShow " + animationClass;

        // ele = document.getElementById("dialog");
        // ele.className = "msgBox " + animationClass;
      };

      setTimeout(animation, 100);
    },
    hideMenu() {
      var animation = function() {
        let animationClass = "slipHide";
        var ele = document.getElementById("menuBox");
        ele.className = "menuShow " + animationClass;

        // ele = document.getElementById("dialog");
        // ele.className = "msgBox " + animationClass;
      };

      setTimeout(animation, 100);
    },
    gotoDiv(str) {
      if (str == "about") {
        this.$router.push("/moAbout");
        return false;
      }
      if (str == "contact") {
        this.$router.push("/moContact");
        return false;
      } else {
        this.$router
          .push({
            path: "/moIndex",
            query: {
              id: str
            }
          })
          .catch(data => {});
        this.$emit("gotoDiv", str);
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
// 弹窗菜单
.menuShow {
  position: fixed;
  background: rgba(0, 0, 0, 1);
  z-index: 3;
  width: 100%;
}
.menuBox {
  color: #fff;
  font-size: 2rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
}
.menuList a {
  color: #fff;
}
.menuList ul > li {
  text-align: center;
  width: 100%;
  height: 3rem;
  border-bottom: 1px solid #1f1f1f;
  line-height: 3rem;
  font-size: 0.8rem;
}
/* 动画 */
.none {
  display: none;
}
.menuShow {
  position: fixed;
  z-index: 2000;
  left: 50%;

  -webkit-animation-duration: 500ms;
  -moz-animation-duration: 500ms;
  -o-animation-duration: 500ms;
  animation-duration: 500ms;
  -webkit-perspective: 1300px;
  -moz-perspective: 1300px;
  perspective: 1300px;
}

.menuShow.slipShow {
  top: 12rem;
  opacity: 1;

  -webkit-animation-name: dialogSlipToUp;
  -moz-animation-name: dialogSlipToUp;
  -o-animation-name: dialogSlipToUp;
  animation-name: dialogSlipToUp;
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  /* 实现水平垂直居中 */
  transform: translate(-50%, -50%);
}

.menuShow.slipHide {
  top: 100%;
  opacity: 0.3;
  -webkit-animation-duration: 500ms;
  -moz-animation-duration: 500ms;
  -o-animation-duration: 500ms;
  animation-duration: 500ms;
  -webkit-animation-name: dialogSlipToBottom;
  -moz-animation-name: dialogSlipToBottom;
  -o-animation-name: dialogSlipToBottom;
  animation-name: dialogSlipToBottom;
  -webkit-transform: translate(-50%, 0);
  -o-transform: translate(-50%, 0);
  -moz-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

@keyframes showMenuBox {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@keyframes hideMenuBox {
  0% {
    opacity: 0.7;
    visibility: visible;
  }

  100% {
    visibility: hidden;
    opacity: 0;
  }
}
@keyframes dialogSlipToUp {
  0% {
    top: 0;
    opacity: 0.3;
  }

  100% {
    top: 12rem;
    opacity: 1;
  }
}
@keyframes dialogSlipToBottom {
  0% {
    top: 12rem;
    opacity: 1;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  100% {
    top: -12rem;
    opacity: 0.3;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/mobile/common/header.vue